module.exports = __webpack_public_path__ + "img/add-new-employee.9b37a90a.png";